import type { SkillCategories } from "./types";

export const layoutConditionGroup = "layout_condition";

export function skillPickerSections(
  categories: SkillCategories,
  query: string,
) {
  const normalized = query.trim().toLocaleLowerCase("ja");
  const shown = categories.filter((category) =>
    category.skills.some((skill) =>
      `${category.label} ${skill.label} ${skill.description ?? ""}`
        .toLocaleLowerCase("ja")
        .includes(normalized),
    ),
  );
  return {
    isSearching: normalized.length > 0,
    mainCategories: shown.filter(
      (category) => category.groupCode !== layoutConditionGroup,
    ),
    conditionCategories: shown.filter(
      (category) => category.groupCode === layoutConditionGroup,
    ),
    hasConditionCategories: categories.some(
      (category) =>
        category.groupCode === layoutConditionGroup &&
        category.skills.length > 0,
    ),
  };
}
